import {
  DEFAULT_APP_TIMEZONE_PREFERENCE,
  type AppTimezonePreference,
  readStoredAppTimezonePreference,
  resolveSelectedTimezoneHeader,
} from '@sparkai/utils'

export const SPARK_SELECTED_TIMEZONE_HEADER = 'spark-selected-timezone'

let selectedTimezoneHeaders = getSelectedTimezoneHeaders(readStoredAppTimezonePreference())

export function getSelectedTimezoneHeaders(preference: AppTimezonePreference): Record<string, string> {
  const selectedTimezone = resolveSelectedTimezoneHeader(preference) ?? 'UTC'
  return { [SPARK_SELECTED_TIMEZONE_HEADER]: selectedTimezone }
}

export function setSelectedTimezonePreference(preference: AppTimezonePreference | null | undefined) {
  selectedTimezoneHeaders = getSelectedTimezoneHeaders(preference ?? DEFAULT_APP_TIMEZONE_PREFERENCE)
}

export function getSelectedTimezoneContextHeaders() {
  return selectedTimezoneHeaders
}
